import type { KidneyStatus, Comorbidity, DialysisType } from '../types/onboarding'
import { appFluidLimit, appNutrientLimits, toAppCondition } from './appLimits'

interface NutrientLimits {
  sodium: number
  potassium: number
  phosphorus: number
  protein: number
  fluid: number | null
}

/**
 * The daily limits the plan screens and the Loops plan email show. Since 2026-10-22
 * these are the app's own defaults (`appLimits.ts`, parity-tested against the app), so
 * a lead sees the same numbers in the funnel, the email and the app. The funnel used
 * to keep its own table (e.g. Stage 3a/3b potassium 2,700 mg where the app uses 2,500).
 * `fluid` is null when the app sets no default fluid limit (peritoneal dialysis).
 */
export function calculateNutrientLimits(
  kidneyStatus: KidneyStatus | null,
  comorbidities: Comorbidity[],
  weightKg: number | null,
  dialysisType?: DialysisType | null,
): NutrientLimits {
  const weight = weightKg || 70
  const condition = toAppCondition(kidneyStatus)
  const limits = appNutrientLimits(condition, comorbidities, dialysisType)
  const fluid = appFluidLimit(condition, dialysisType)

  return {
    sodium: limits.sodium,
    potassium: limits.potassium,
    phosphorus: limits.phosphorus,
    protein: Math.round(weight * limits.proteinPerKg),
    fluid: fluid > 0 ? fluid : null,
  }
}
